import Dashboard from '../components/Dashboard/Dashboard';
import BasicAppPageWithSidebarTemplate from '../templates/BasicAppPageWithSidebarTemplate/BasicAppPageWithSidebarTemplate';
export default function DashboardPage() {
  return (
    <BasicAppPageWithSidebarTemplate>
      <Dashboard />
    </BasicAppPageWithSidebarTemplate>
  );
}
